export default {
  //top-nav
  navHome: "首页",
  navProspect: "潜在客户",
  navCompanies: "公司",
  navEnrich: "数据丰富",
  navIntent: "网站意图",
  navSequence: "工作流程",
  navInbox: "收件箱",
  navInboxDesc: "在一个地方阅读和回复邮件和 LinkedIn 消息",
  inboxSearchPlaceholder: "搜索对话",
  inboxEmptyState: "暂无对话。当您的工作流开始运行后,回复将在这里显示。",
  inboxEmptyConnectCta: "设置工作流",
  channelEmail: "邮件",
  channelLinkedIn: "领英",
  inboxMsgYou: "您",
  inboxSelectThreadTitle: "选择一个对话",
  inboxThreadErrorTitle: "无法加载此对话",
  inboxThreadErrorHint: "该对话没有可用的渠道连接，或数据已不可用。",
  inboxComposerHint: "按 ⌘ + Enter 发送",
  inboxToggleProspect: "切换潜在客户详情",
  inboxChannelFilter: "渠道筛选",
  inboxProspectContact: "联系方式",
  inboxProspectSequence: "工作流",
  inboxProspectActivity: "动态",
  inboxProspectLastInbound: "最近回复",
  inboxProspectLastOutbound: "最近发送",
  inboxProspectStatus: "状态",
  inboxProspectNoContact: "暂无联系方式。",
  inboxBulkSelected: "已选择",
  inboxBulkMarkRead: "已读",
  inboxBulkToggle: "选择对话",
  inboxTabProfile: "资料",
  inboxTabActivity: "动态",
  inboxActivityEmpty: "此对话暂无动态。",
  inboxInsertVariable: "变量",
  inboxVarFullName: "全名",
  inboxVarCompany: "公司",
  inboxVarTitle: "职位",
  inboxSequenceStep: "步骤",
  inboxSequenceRunning: "运行中",
  inboxSequencePaused: "已暂停",
  inboxSequenceFinished: "已完成",
  inboxSequenceArchived: "已归档",
  inboxAsideConversations: "条对话",
  inboxBulkToggleAll: "选择本页全部",
  inboxSortBy: "排序",
  inboxSortRecent: "最新优先",
  inboxSortOldest: "最早优先",
  inboxSortSender: "发件人 (A→Z)",
  inboxSortSubject: "主题 (A→Z)",
  inboxSortReplied: "已回复优先",
  last_message_at: "最新消息",
  first_message_at: "首条消息",
  reference_id: "发件人",
  subject: "主题",
  inboxAccountSingular: "个账号",
  inboxAccountPlural: "个账号",
  inboxRecentReplies: "最近回复",
  inboxConnectedAs: "连接自",
  inboxActionInterested: "标记为感兴趣",
  inboxActionMarkAll: "全部标记",
  inboxSelectThreadHint: "请选择一个对话以查看消息。",
  inboxReplyPlaceholder: "输入回复…",
  inboxSuggestReply: "AI 建议回复",
  inboxSend: "发送",
  inboxFilterAll: "全部",
  inboxFilterUnread: "未读",
  inboxFilterReplied: "已回复",
  inboxFilterSnoozed: "稍后处理",
  inboxFilterClosed: "已关闭",
  inboxActionSnooze: "稍后处理",
  inboxActionMeetingBooked: "标记为已预约会议",
  inboxActionNotInterested: "标记为不感兴趣",
  inboxActionArchive: "归档",
  inboxActionStopSequence: "停止工作流",
  inboxArchetypeConcise: "简洁",
  inboxArchetypeWithCta: "带行动呼吁",
  inboxArchetypeQuestionBack: "反问",
  actions: "操作",
  loading: "加载中…",
  navService: "企业服务",
  navAccountCredit: "账户信用点",
  navSetting: "设置",
  navSequenceDetail: "工作流程详情",
  companyDetail: "公司详情",

  // nav desc
  filterYourSearchToFindPreciselyTargeted:
    "筛选您的搜索，以找到目标明确的公司列表",
  filterYourSearchToFindHighlySpecific:
    "筛选您的搜索，以找到高度特定的目标潜在客户群",
  instantlyEnhanceYourData:
    "通过添加来自各种来源的有价值的见解和关键细节，立即增强您的数据",
  transformAnonymousWebsiteTrafficInto:
    "通过实时识别将匿名网站流量转化为B2B潜在客户",
  personalizeYourOutreach:
    "自动化和个性化您的外展活动，以节省时间并吸引潜在客户",
  comprehensiveBusinessSolutions: "满足您需求的全面业务解决方案和支持服务",

  discoverAndConnectWithPotentialBuyers: "发现并与潜在客户联系",
  activelySeekingYourSolutionToday: "今天积极寻求您的解决方案",
  Market_Intent: "市场意图",
  Tools: "工具",
  technologyLookup: "技术查询",
  domainLookup: "域名查询",
  emailVerification: "电子邮件验证",
  upgrade: "升级",
  replayMonitorTour: "重播监控器导览",
  replayOnboardingTour: "重播入门导览",
  tourDuration: "2 分钟",
  helpCenter: "帮助中心",
  contactUs: "联系我们",
  feedback: "反馈",
  hello: "你好",
  clickToChange: "点击更改",
  yourProfile: "您的个人资料",
  currentUsage: "当前使用情况",
  upgradePlan: "升级计划",
  integrations: "集成",
  featureRequests: "功能请求",
  change: "更改",
  en: "英文",
  cn: "中文（简）",
  tw: "中文（繁）",
  logout: "登出",
  switchLanguage: "成功切换语言",

  // button operation
  btnEdit: "编辑",
  btnDelete: "删除",
  btnCancel: "取消",
  btnFilters: "筛选",
  btnView: "查看",
  btnAdd: "添加",
  btnRemove: "移除",

  // 操作提示
  removeSuccessfully: "移除成功",
  saveSuccessfully: "保存成功",
  createSuccessfully: "创建成功",

  // 系统popup
  unableToProcessPayment: "无法处理付款：无法在您最近的支付中上完成付款。",
  billingSettings: "账单设置",

  // wallet
  topupCredit: "充值信用点",
  autoTopup: "自动充值",
  lastCalculated: "最后计算时间",
  Enabled: "是",
  Disabled: "否",

  // user
  btnUpgrade: "升级",

  // app update toast
  newVersionAvailable:
    "<strong>新版本已发布</strong> — 重新加载以获取最新功能和修复。本页面未保存的更改可能会丢失。",
  Reload: "重新加载",
  // TODO: translate (placeholders copied from en.js)
  inboxStatsToday: "Today",
  inboxStatsReplies: "Replies",
  inboxStatsPending: "Pending",
  inboxStatsActiveSequences: "Active sequences",
  inboxOpenEmpty: "Open the inbox to see your latest replies.",
  inboxRefresh: "Refresh inbox",
  inboxSuggestFollowUp: "Suggest follow-up",
  inboxInsightAge: "Age",
  inboxSuggestModePick: "Choose draft type",
  inboxSuggestModeReply: "Reply (prospect wrote last)",
  inboxSuggestModeFollowUp: "Follow-up (we wrote last)",
  inboxSuggestModeAuto: "Auto (detect from thread)",
  inboxFilterArchived: "Archived",
  inboxFilterDone: "Done",
  inboxStatusMeetingBooked: "Meeting booked",
  inboxStatusNotInterested: "Not interested",
  inboxStatusInterested: "Interested",
  inboxFilterOpen: "Active",
  inboxMsgSent: "Sent",
  inboxClickToOpen: "Click to open",
  inboxKpiSentToday: "Sent today",
  inboxKpiUnread: "Unread",
  inboxKpiRepliedToday: "Replies",
  inboxKpiSentWeek: "Sent this week",
  inboxKpiInbox: "in inbox",
  inboxKpiTotal: "total",
  inboxGlanceTopSequences: "Top sequences (30 days)",
  inboxLinkBtn: "Link",
  inboxLinkPromptUrl: "Link URL",
  inboxLinkPromptErr: "Enter a URL starting with http(s)://",
  inboxComposerDropHint: "Drop to attach",
  inboxFilterChannel: "Channel",
  inboxFilterCredential: "Credential",
  inboxFilterSequence: "Sequence",
  inboxFilterStatus: "Status",
  inboxFilterClassification: "Reply type",
  inboxFilterDateRange: "Date range",
  inboxFilterDateRangePh: "Pick a date range",
  inboxFilterClass_real: "Real replies only",
  inboxFilterClass_bounce: "Bounces",
  inboxFilterClass_auto_reply: "Auto-replies",
  inboxClassBounce: "Bounce",
  inboxClassBounceHint: "Delivery failed — this isn't a real reply",
  inboxClassAutoReply: "Auto-reply",
  inboxClassAutoReplyHint: "Automated out-of-office / vacation responder",
  inboxStepEvents: "events",
  inboxBulkMarkUnread: "Unread",
  inboxBulkInterested: "Interested",
  inboxBulkNotInterested: "Not interested",
  inboxSnoozeDialogTitle: "Snooze until",
  inboxSnoozeCustom: "Pick a custom date and time",
  inboxSnoozeCustomPh: "Select date & time",
  inboxSnoozeConfirm: "Snooze",
  inboxSnoozePreset1h: "Later today (1h)",
  inboxSnoozePreset4h: "Later today (4h)",
  inboxSnoozePresetTom: "Tomorrow morning",
  inboxSnoozePresetMon: "Next Monday",
  inboxSnippetBtn: "Snippets",
  inboxSnippetSearch: "Search snippets",
  inboxSnippetNew: "New snippet",
  inboxSnippetManage: "Manage",
  inboxSnippetCreate: "Create your first snippet",
  inboxSnippetCreateTitle: "New snippet",
  inboxSnippetEditTitle: "Edit snippet",
  inboxSnippetManager: "Manage snippets",
  inboxSnippetEmpty: "No saved snippets yet.",
  inboxSnippetFieldName: "Name",
  inboxSnippetFieldChannel: "Channel (optional)",
  inboxSnippetFieldBody: "Body",
  inboxSnippetChannelAny: "Any channel",
  inboxSnippetNamePh: "e.g. Friendly follow-up",
  inboxSnippetBodyPh: "Hi {{first_name}}, just following up…",
  btnSave: "Save",
  inboxProspectTracking: "Tracking",
  inboxOpened: "Opened",
  inboxClicked: "Clicked",
  inboxLast: "last",
  of: "of",
  inboxAttachBtn: "Attach",
  inboxAttachTooBig: "Total attachment size exceeds 24MB.",
  noData: "No results",
  inboxCopy: "Copy",
  inboxCopied: "Copied",
  inboxCopyEmail: "Copy email",
  inboxCopiedEmail: "Email copied",
  inboxCopyPhone: "Copy phone",
  inboxCopiedPhone: "Phone copied",
  inboxOpenLinkedIn: "Open LinkedIn",
  inboxOpenTwitter: "Open X / Twitter",
  inboxProspectCompany: "Company",
  inboxProspectInsights: "Insights",
  inboxInsightMessages: "Messages",
  inboxInsightSince: "Open",
  inboxAgeToday: "Today",
  inboxEmptyTitle: "No conversations yet",
  inboxSelectionPicker: "Selection options",
  inboxSelectionTitle: "Select conversations",
  inboxSelectThisPage: "This page",
  inboxSelectAll: "All conversations",
  inboxSelectCustom: "Custom",
  inboxSelectAllHint:
    "Selecting beyond this page fetches additional pages from the server.",
  applySelection: "Apply",
  theQuantityCannotBeZero: "Pick a non-zero count",
  inboxCompanyName: "Name",
  inboxCompanyIndustry: "Industry",
  inboxCompanySize: "Size",
  inboxCompanyLocation: "Location",
  inboxCompanyWebsite: "Website",
  inboxCompanyLinkedIn: "LinkedIn",
  inboxShowTrimmed: "Show trimmed content",
  inboxShowTrimmedHint: "Show the rest of this message",
  inboxFieldTo: "To",
  inboxFieldToPh: "recipient@example.com",
  inboxFieldToLinkedInPh: "Recipient",
  inboxFieldCc: "Cc",
  inboxFieldCcPh: "cc@example.com, …",
  inboxFieldBcc: "Bcc",
  inboxFieldBccPh: "bcc@example.com, …",
  inboxFieldSubject: "Subject",
  inboxFieldSubjectPh: "Subject",
  inboxFieldLocked: "Auto-filled — cannot edit",
  inboxTrackSent: "Sent",
  inboxTrackSentHint: "Messages we sent in this thread",
  inboxTrackReplies: "Replies",
  inboxTrackRepliesHint: "Inbound messages from the prospect",
  inboxTrackOpens: "Opens",
  inboxTrackOpensHint: "Times the recipient opened a tracked message",
  inboxTrackClicks: "Clicks",
  inboxTrackClicksHint: "Tracked links the recipient clicked",
  inboxTrackReads: "Reads",
  inboxTrackReadsHint:
    "Times the recipient read this thread (LinkedIn read receipts)",
  inboxTrackReactions: "Reactions",
  inboxTrackReactionsHint: "Reactions on our outbound messages",
  inboxMsgNoOpenYet: "No opens recorded yet",
  inboxMsgNoClickYet: "No clicks recorded yet",
  inboxActivityReplyReceived: "Reply received",
  inboxActivityOpenRecorded: "Email opened",
  inboxActivityClickRecorded: "Link clicked",
  inboxActivitySendEmail: "Email sent",
  inboxActivitySendLinkedIn: "LinkedIn message sent",
  inboxActivitySendInvite: "LinkedIn invite sent",
  inboxActivityFailed: "failed",
  inboxComposerExpand: "Expand composer",
  inboxComposerCollapse: "Collapse composer",
  inboxComposerMinimise: "Minimise composer",
  inboxComposerRestore: "Restore composer",
  inboxComposerReply: "Reply…",
  inboxReplyModeReply: "Reply",
  inboxReplyModeReplyAll: "Reply all",
  inboxRecipientNoMatch: "Type an email and press Enter",
  inboxSignatureToggle: "Toggle signature",
  inboxSignatureTitle: "Email signature",
  inboxSignaturePh: "Best regards,\nYour name",
  inboxSignatureOn: "Signature ON — click to remove",
  inboxSignatureOff: "Signature OFF — click to insert",
  inboxSignatureRightClickEdit: "right-click to edit",
  inboxSignatureRightClickHint:
    "Tip: right-click the signature button to edit.",
  Refresh: "Refresh",
  Show: "Show",
  Hide: "Hide",
  Next: "Next",
  // pagination
  pagination_per_page: "{size} / 页",
  pagination_go_to: "前往",
};
